import model from './model';

const selectors = {
  root: '#socialRoot',
  shareButtons: '#shareButtons',
} as const;

export default model.createController(({ $w }) => {
  return {
    pageReady: async () => {
      ($w(selectors.shareButtons) as unknown as { pageToShare: string }).pageToShare = 'current';
    },
    exports: {},
  };
});
